module.exports = __webpack_public_path__ + "static/media/muji ui1.91f6f63a.png";